export default __webpack_public_path__ + "static/media/bg-head-mobile.8652d898.png";